import useBreakpoint from 'src/common/hooks/ui/useBreakpoint'
import NavBarDesktop from './NavBar.desktop'
import NavBarMobile from './NavBar.mobile'

export interface NavBarProps {
  className?: string
}

const NavBar: React.FC<NavBarProps> = ({ className }) => {
  const isMd = useBreakpoint('md')

  if (isMd) return <NavBarMobile className={className} />
  return <NavBarDesktop className={className} />
}

export default NavBar
